import { ValidationErrors, ValidatorFn, AbstractControl, FormGroup } from "@angular/forms";

/* BHR start cannon be greater than end unless day is disabled */
export function bhrDayValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const startControl = control.get("start");
    const endControl = control.get("end");
    const disabledControl = control.get("disabled");
    if (startControl && endControl && disabledControl) {
      const start = startControl.value;
      const end = endControl.value;
      // TODO split the error cases out
      return disabledControl.value ||
        !startControl.value ||
        !endControl.value ||
        start.h * 60 + start.m < end.h * 60 + end.m
        ? // eslint-disable-next-line no-null/no-null
          null
        : { isBhrDay: true };
    } else {
      // eslint-disable-next-line no-null/no-null
      return null;
    }
  };
}

/* BHR Time Required, ensures a valid bhr time is assigned to form control */
export function bhrTimeRequiredValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (control instanceof FormGroup) {
      const start = control.value.start;
      const end = control.value.end;
      if (
        start &&
        start.h !== undefined &&
        start.m !== undefined &&
        end &&
        end.h !== undefined &&
        end.m !== undefined
      ) {
        return (start.h === -1 && start.m === 0) || (end.h === -1 && end.m === 0)
          ? { bhrTimeRequired: true }
          : // eslint-disable-next-line no-null/no-null
            null;
      }
    }
    // eslint-disable-next-line no-null/no-null
    return null;
  };
}
